import { CSS } from '@grupoboticario/flora-react'

export const outerBoxCss: CSS = {
  margin: '$7 0 $5'
}

export const sectionBoxCss: CSS = {
  margin: '$7 0'
}

export const fieldGroupCss: CSS = {
  marginBottom: '$7'
}

export const contactRowCss: CSS = {
  flexDirection: 'column',
  '@desktop': { flexDirection: 'row' }
}

export const actionRowCss: CSS = {
  flexDirection: 'column',
  '@desktop': {
    flexDirection: 'row'
  }
}

export const actionsWrapperCss: CSS = {
  flexDirection: 'column',
  width: '100%',
  '@desktop': {
    flexDirection: 'row',
    width: 'auto'
  }
}

export const fullWidthButtonCss: CSS = {
  width: '100%',
  '@desktop': { width: 'auto' }
}
